import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola.jsx";
import Modbury5images from "../../Media/Cibubur/Modbury/Modbury 5/Modbury5.js";
import Modbury6images from "../../Media/Cibubur/Modbury/Modbury 6/Modbury6.js";
import Modbury8images from "../../Media/Cibubur/Modbury/Modbury 8/Modbury8.js";

const imageMap = {
  Modbury5images,
  Modbury6images,
  Modbury8images,
};

const produk = () => {
  return (
    <div id="modbury" className="produk">
      <h1>New Launching Citraland Cibubur</h1>
      <h2>Modbury</h2>
      <h3>Cicilan Start From 2 Juta/Bulan</h3>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
